module.exports = __webpack_public_path__ + "img/logo-48.5e14d0d.png";